<mat-card data-at-card [class.dialog]="dialog" [class.auto-height]="autoHeight">
  <mat-card-title data-at-card-title *ngIf="title" [class.title]="title">
    <ng-content select="[title]"></ng-content>
  </mat-card-title>
  <mat-card-content data-at-card-body>
    <ng-content select="[body]"></ng-content>
  </mat-card-content>
  <mat-card-actions
    data-at-card-footer
    *ngIf="footer"
    class="flex flex-row justify-end items-center"
  >
    <ng-content select="[footer]"></ng-content>
  </mat-card-actions>
</mat-card>
